import * as React from 'react';
import UnderConstruction from '../common/UnderConstruction';

const CustomerAnalysisPanel = ({accessToken, customerId}) => {
    return (
        <UnderConstruction title='customer analysis panel'/>
    );
}

export default CustomerAnalysisPanel;